let HeroButton = {
	init: function(){
		let heroButtons = jQuery('.hero-button-wrapper');
		if(heroButtons.length > 1){
			jQuery(heroButtons[0]).addClass('first-hero');
		}
	}
}